<div class="c-switch__track">
  <span class="c-switch__circle"></span>
</div>
<span class="c-switch__label">{{label}}</span>
